<template>
	<AppButton
		:label="$t('settings.new-group')"
		startIcon="assets/v2/image/icons/plus.svg"
		@click="onAddClick"
	/>
</template>

<script setup>
import { useI18n } from 'vue-i18n';
import { useLocationGroupsStore } from '../../../stores/location-groups';
import { Alert } from '@/v2/plugins/alert';

const { t } = useI18n();
const locationGroupsStore = useLocationGroupsStore();

const onAddClick = () => {
	if (locationGroupsStore.groups.length === 10) {
		Alert.error(t('settings.you-cant-create-more-than-10-groups'));
		return;
	}
	locationGroupsStore.addNewGroup();
};
</script>

<style lang="scss" scoped></style>
